import { lazy } from 'react';

import type { TabKenh } from '../channels/tabRegistry.js';

/**
 * Bốn mục của module 07 trên trang kênh — **ba tab con cũ đã dàn ra tab chính**
 * (bước 3, 22/10/2026):
 *
 * | Tab con cũ của "Số liệu phân tích về kênh" | Mục | Tab |
 * |---|---|---|
 * | Tổng quan | `hieu-suat` | Tổng quan |
 * | Đối tượng người xem | `doi-tuong` | Tổng quan |
 * | Doanh thu | `hieu-suat-doanh-thu` | Doanh thu & chia sẻ (đầu tab) |
 * | Nội dung (đã tách từ bước 2) | `noi-dung` | Nội dung & nhạc |
 *
 * `hieu-suat-doanh-thu` lấy order **5** để đứng trước mọi khối theo tháng của
 * tab Doanh thu & chia sẻ: doanh thu YouTube theo ngày là số gốc, dòng tiền và
 * phần chia đọc sau.
 */
const channelTabs: TabKenh[] = [
  {
    id: 'hieu-suat',
    nhom: 'tong-quan',
    label: 'Hiệu suất kênh',
    order: 60,
    permission: { module: 'analytics', level: 'view' },
    component: lazy(() => import('./components/TabHieuSuat.js')),
  },
  {
    id: 'doi-tuong',
    nhom: 'tong-quan',
    label: 'Đối tượng người xem',
    order: 70,
    permission: { module: 'analytics', level: 'view' },
    component: lazy(() => import('./components/TabDoiTuongCuaKenh.js')),
  },
  {
    id: 'hieu-suat-doanh-thu',
    nhom: 'doanh-thu-chia-se',
    cot: 'trai',
    label: 'Doanh thu theo ngày',
    order: 5,
    /*
     * Quyền **`revenue`**, không phải `analytics` — rà soát bảo mật 31/10/2026,
     * mục S5. Cả mục này là tiền, và từ đợt 7 endpoint của nó
     * (`GET /analytics/kenh/:id/doanh-thu`) trả **403** cho người thiếu
     * `revenue:view`. Khai `analytics` ở đây là hiện một mục chắc chắn lỗi
     * cho vai trò "Biên tập / Dựng" — đúng lớp lỗi của đợt 6.
     */
    permission: { module: 'revenue', level: 'view' },
    component: lazy(() => import('./components/TabDoanhThuKenh.js')),
  },
  {
    id: 'noi-dung',
    nhom: 'noi-dung-nhac',
    label: 'Nội dung đã đăng',
    order: 10,
    permission: { module: 'analytics', level: 'view' },
    component: lazy(() => import('./components/TabNoiDungCuaKenh.js')),
  },
];

export default channelTabs;
